import React from 'react';
import SalesProfitForm from '../../../components/chancemng/obtainorder/SalesProfitForm';

const SalesProfitFormContainer = ({ orderInfo, chance, formik }) => {
  if (!orderInfo) {
    return null;
  }

  return (
    <SalesProfitForm orderInfo={orderInfo} formik={formik} chance={chance} />
  );
};

export default SalesProfitFormContainer;
